import { Button } from "antd";
import { useTranslation } from "react-i18next";

interface button {
  onClick: any;
  disabled?: boolean
}
const ResetButton = ({ onClick, disabled }: button) => {
  const [t] = useTranslation("common");

  return (
    <Button
      disabled={disabled}
      style={{
        color: "#1677FF",
        border: "1px solid #1677FF",
        height: "40px",
        width: "80px"
      }}
      onClick={onClick}
    >
      {t("reset")}
    </Button>
  );
};

export default ResetButton;
